import BaseController from "confinus_ui/base_controller";

export default abstract class PurchaseConfiguratorVariantAbstract extends BaseController {
  public static values = {
    variantEncodedId: { type: String, default: null },
  };

  declare protected readonly variantEncodedIdValue: String;

  public get id() {
    return this.variantEncodedIdValue;
  }

  public set isCurrent(isCurrent: boolean) {
    const classToToggle =
      "shopping__purchase-configurator__variant-details--current";
    // IE11 don't support second parameter in classList.toggle(classNmae, condition)
    isCurrent
      ? this.element.classList.add(classToToggle)
      : this.element.classList.remove(classToToggle);
  }
}
